import $api from "../../../http";

export const getTeams = async (filters) => {
  return await $api
    .post(`/team/list`, filters)
    .then((response) => {
      return { response: response.data, status: response.status };
    });
};
